import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function IconActionButton({icon,onClick,hint}) {
    return (
        <button onClick={onClick} className='no-style'>
        <FontAwesomeIcon className='header-nav-icon' icon={icon} title={hint} />
        </button>
    );
}

export default IconActionButton;